import { CSSProperties } from 'react';

export const styles = {
  // Review Card
  reviewCard: {
    background: 'white',
    border: '2px solid #f59e0b',
    borderRadius: 16,
    overflow: 'hidden',
    boxShadow: '0 8px 24px rgba(245, 158, 11, 0.12)'
  } as CSSProperties,

  // Card Header
  cardHeader: {
    background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
    padding: '20px 24px',
    borderBottom: '1px solid #fbbf24',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'default'
  } as CSSProperties,

  cardIcon: {
    width: 48,
    height: 48,
    background: 'white',
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)'
  } as CSSProperties,

  statusBadge: {
    background: '#fbbf24',
    color: '#78350f',
    fontSize: 11,
    fontWeight: 700,
    padding: '6px 16px',
    borderRadius: 20,
    textTransform: 'uppercase' as const,
    letterSpacing: '0.5px',
    height: 25,
    display: 'flex',
    alignItems: 'center',
    cursor: 'default',
    borderColor: 'transparent'
  } as CSSProperties,

  // Editor
  editorSection: {
    padding: 24,
    cursor: 'default'
  } as CSSProperties,

  textarea: {
    width: '100%',
    minHeight: 200,
    padding: 16,
    fontSize: 14,
    lineHeight: 1.8,
    fontFamily: "'Courier New', monospace",
    background: '#f8fafc',
    border: '2px solid #e2e8f0',
    borderRadius: 10,
    resize: 'vertical' as const,
    transition: 'all 0.2s'
  } as CSSProperties,

  editorNote: {
    marginTop: 12,
    padding: '12px 16px',
    background: '#f1f5f9',
    borderRadius: 8,
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10
  } as CSSProperties,

  // Footer
  cardFooter: {
    padding: '20px 24px',
    background: '#fafafa',
    borderTop: '1px solid #e5e7eb',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  } as CSSProperties,

  confirmButton: {
    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    color: 'white',
    border: 'none',
    padding: '12px 32px',
    fontSize: 15,
    fontWeight: 600,
    borderRadius: 10,
    cursor: 'pointer',
    boxShadow: '0 4px 16px rgba(16, 185, 129, 0.3)',
    transition: 'all 0.2s',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    height: 44
  } as CSSProperties
};
